import React, { useEffect } from 'react';
import SelectTwo, { SelectTwoMapperOptions } from '../../../../components/SelectTwo';
import { Society } from '../../../../app/models/Society';
import { Client } from '../../../../app/models/Client';
import { Currency } from '../../../../app/models/Currency';
import { PaymentCondition } from '../../../../app/models/PaymentCondition';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { QuoteDataForm, QuoteOfferTypeDataForm, QuoteReferenceDataForm } from '../../../../app/models/Quote';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import { setCleanTextAreaError } from '../../../../utils/utils';
import LazyLoading from '../../../../components/LazyLoading';
import { Sector } from '../../../../app/models/Sector';
import { SectorBusinessRulesEnum } from '../../../../app/shared/enums';
import { ClientContact } from '../../../../app/models/ClientContact';

interface GeneralQuoteFormProps {
    quoteForm: QuoteDataForm;
    setQuoteForm: (quote: QuoteDataForm) => void;
    societies: Society[];
    clients: Client[];
    clientContacts: ClientContact[];
    currencies: Currency[];
    references: QuoteReferenceDataForm[];
    offerTypes: QuoteOfferTypeDataForm[];
    paymentMethods: PaymentCondition[];
    sectors: Sector[];

    errorFields?: Record<string, unknown>;
    condition?: boolean;
    isCreated?: boolean;
    disableUpdate?: boolean;
    loadingClient?: boolean;
    isEdit?: boolean;

    
}

const QuoteForm = ({
    quoteForm,
    setQuoteForm,
    societies,
    clients,
    paymentMethods,
    references,
    offerTypes,
    currencies,
    errorFields,
    condition,
    isCreated = false,
    disableUpdate = false,
    loadingClient,
    sectors,
    clientContacts,
    isEdit
}: GeneralQuoteFormProps) => {
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors, errors } = useHandleErrorFields();

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const handleChange = (
        event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>
    ) => {
        const { name, value } = event.target;
        setQuoteForm({ ...quoteForm, [name]: value });
    };

    const handleChangeSelectTwo = (name: string, value: number | string | null) => {

        if(name === 'society_id'){
            setErrors(
                {
                    ...errors,
                    client_id:''
                }
            )
        }
        setQuoteForm({ ...quoteForm, [name]: value });
    };

    const handleChangeSelectTwoClient = (name: string, value: number | string | null) => {
        setQuoteForm({
            ...quoteForm,
            [name]: value,
            // contact_email: clientContacts.find((client_contact) => client_contact.id == value)?.email || ''
        });
    };

    const handleChangeSelectTwoSector = (name: string, value: number | string | null) => {
        setQuoteForm({
            ...quoteForm,
            [name]: value
        });


    };
    const handleChangeSelectTwoClientContacts = (name: string, value: number | string | null) => {
        setQuoteForm({
            ...quoteForm,
            [name]: value,
            // contact_email: clients.find((client) => client.id == value)?.email || ''
            contact_email: clientContacts.find((client_contact) => client_contact.id == value)?.email || ''

        });


    };

    if (!quoteForm) return null;

    return (
        <>


            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Sector</label>
                <div className="col-md-9">
                    <SelectTwo
                        name="sector_id"
                        id="sector_id"
                        inputValue={quoteForm.sector_id}
                        options={SelectTwoMapperOptions(sectors, 'id', ['name'])}
                        hasError={fieldHasError('sector_id') !== ''}
                        onChange={(value) =>
                            handleChangeSelectTwoSector('sector_id', value?.value ?? null)
                        }
                        placeholder="Seleccione un sector"
                        onFocus={() => onFocusRemove('sector_id')}
                        disabled={disableUpdate}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('sector_id')}
                    </div>
                </div>
            </div>
            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Sociedad</label>
                <div className="col-md-9">
                    <SelectTwo
                        name="society_id"
                        id="society_id"
                        inputValue={quoteForm.society_id}
                        options={SelectTwoMapperOptions(societies)}
                        hasError={fieldHasError('society_id') !== ''}
                        onChange={(value) => handleChangeSelectTwo('society_id', value?.value ?? null)}
                        placeholder={'Seleccione una sociedad'}
                        onFocus={() => onFocusRemove('society_id')}
                        disabled={disableUpdate}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('society_id')}
                    </div>
                </div>
            </div>
                {loadingClient ? (
                <LazyLoading height={300} />
                ) : (
                <div className="mb-2 row">
                    <label className="col-md-3 col-form-label">Cliente</label>
                    <div className="col-md-9">
                    <SelectTwo
                        name="client_id"
                        id="client_id"
                        inputValue={quoteForm.client_id}
                        options={SelectTwoMapperOptions(clients, 'id')}
                        hasError={fieldHasError('client_id') !== ''}
                        onChange={(value: any) =>
                        handleChangeSelectTwoClient('client_id', value.value)
                        }
                        placeholder="Seleccione un cliente"
                        onFocus={() => onFocusRemove('client_id')}
                        disabled={disableUpdate}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('client_id')}
                    </div>
                    </div>
                </div>
                )}

            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Contacto</label>
                <div className="col-md-9">
                    <SelectTwo
                    name="client_contact_id"
                    id="client_contact_id"
                    inputValue={quoteForm.client_contact_id}
                    options={SelectTwoMapperOptions(clientContacts, 'id')}
                    hasError={fieldHasError('client_contact_id') !== ''}
                    onChange={(value: any) =>
                        handleChangeSelectTwoClientContacts('client_contact_id', value.value)
                    }
                    placeholder="Seleccione un contacto"
                    onFocus={() => onFocusRemove('client_contact_id')}
                    disabled={disableUpdate} 
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                    {fieldErrorMessage('client_contact_id')}
                    </div>
                </div>
                </div>

                <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Email</label>
                <div className="col-md-9">
                    <input
                    name="contact_email"
                    id="contact_email"
                    type="email"
                    className={`form-control ${fieldHasError('contact_email')}`}
                    value={quoteForm.contact_email}
                    onChange={handleChange}
                    onFocus={() => onFocusRemove('contact_email')}
                    placeholder="Correo contacto"
                    disabled={false} 
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                    {fieldErrorMessage('contact_email')}
                    </div>
                </div>
                </div>

            <div className="mb-2 row">
                <label htmlFor="offer_type" className="col-md-3 col-form-label">
                Tipo de oferta
                </label>
                <div className="col-md-9">
                    <SelectTwo
                        name="offer_type"
                        id="offer_type"
                        inputValue={quoteForm.offer_type}
                        hasError={fieldHasError('offer_type') !== ''}
                        options={SelectTwoMapperOptions(offerTypes)}
                        onChange={(v: any) => handleChangeSelectTwo('offer_type', v.value)}
                        onFocus={() => onFocusRemove('offer_type')}
                        placeholder="Seleccione un tipo de oferta"
                        disabled={disableUpdate}
                    />
                    <div className="invalid-feedback">
                        {fieldErrorMessage('offer_type')}
                    </div>
                </div>
            </div>

            <div className="mb-2 row">
                <OverlayTrigger
                    overlay={
                        <Tooltip id="tooltip-expiration">
                        Se calcula desde la confirmación de la cotización más los días definidos.
                        </Tooltip>
                    }
                >
                    <label htmlFor="expired_in_days" className="col-md-3 col-form-label">
                        Vigencia
                    </label>
                </OverlayTrigger>
                
                <div className="col-md-9 row">
                        <div className="col-md-9">
                            <input
                                type="number"
                                name="expired_in_days"
                                id="expired_in_days"
                                className={`form-control ${fieldHasError('expired_in_days')}`}
                                value={quoteForm.expired_in_days}
                                onChange={handleChange}
                                onFocus={() => onFocusRemove('expired_in_days')}
                                placeholder="Ingrese cantidad de días"
                                disabled={disableUpdate}
                            />
                            <div className="invalid-feedback">
                                {fieldErrorMessage('expired_in_days')}
                            </div>
                        </div>

                        <div className="col-md-3">
                            <label className="col-md-12 col-form-label">
                                días
                            </label>
                        </div>
                    
                </div>
            </div>
  
            {/* <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Forma de Pago</label>
                <div className="col-md-9">
                    <SelectTwo
                        name="payment_method_id"
                        id="payment_method_id"
                        inputValue={quoteForm.payment_method_id}
                        options={SelectTwoMapperOptions(paymentMethods)}
                        hasError={fieldHasError('payment_method_id') !== ''}
                        onChange={(value: any) =>
                            handleChangeSelectTwo('payment_method_id', value.value)
                        }
                        onFocus={() => onFocusRemove('payment_method_id')}
                        placeholder={'Seleccione una forma de pago'}
                        disabled={disableUpdate}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                    {fieldErrorMessage('payment_method_id')}
                    </div>
                </div>
            </div> */}
            {(condition || isCreated) && !isEdit && (
                <>

                    <div className="mb-2 row">
                        <label className="col-md-3 col-form-label">Forma pago</label>
                        <div className="col-md-9">
                            <SelectTwo
                                name="payment_method_id"
                                id="payment_method_id"
                                inputValue={quoteForm.payment_method_id}
                                options={SelectTwoMapperOptions(paymentMethods)}
                                hasError={fieldHasError('payment_method_id') !== ''}
                                onChange={(value) =>
                                    handleChangeSelectTwo('payment_method_id', value?.value ?? null)
                                }
                                onFocus={() => onFocusRemove('payment_method_id')}
                                placeholder={'Seleccione una forma de pago'}
                                disabled={disableUpdate}
                            />
                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                {fieldErrorMessage('payment_method_id')}
                            </div>
                        </div>
                    </div>
                    <div className="mb-2 row">
                        <label className="col-md-3 col-form-label">Cond. pago</label>
                        <div className="col-md-9">
                            <div className="row g-1">
                                <div className="col-9">
                                    <SelectTwo
                                        name="reference"
                                        id="reference"
                                        inputValue={quoteForm.reference}
                                        hasError={fieldHasError('reference') !== ''}
                                        options={SelectTwoMapperOptions(references)}
                                        onChange={(value) => handleChangeSelectTwo('reference', value?.value ?? null)}
                                        onFocus={() => onFocusRemove('reference')}
                                        placeholder="Seleccione Referencia"
                                        disabled={disableUpdate}
                                    />
                                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                                        {fieldErrorMessage('reference')}
                                    </div>
                                </div>
                                <div className="col-3">
                                    <input
                                        name="days_count"
                                        id="days_count"
                                        type="number"
                                        className={`form-control ${fieldHasError('days_count')}`}
                                        value={quoteForm.days_count}
                                        onChange={handleChange}
                                        onFocus={() => onFocusRemove('days_count')}
                                        placeholder="días"
                                        disabled={disableUpdate}
                                    />
                                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                                        {fieldErrorMessage('days_count')}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mb-2 row">
                        <label className="col-md-3 col-form-label">Moneda</label>
                        <div className="col-md-9">
                            <SelectTwo
                                name="currency_id"
                                id="currency_id"
                                inputValue={quoteForm.currency_id}
                                hasError={fieldHasError('currency_id') !== ''}
                                options={SelectTwoMapperOptions(currencies)}
                                onChange={(value) => handleChangeSelectTwo('currency_id', value?.value ?? null)}
                                onFocus={() => onFocusRemove('currency_id')}
                                placeholder={'Seleccione una Moneda'}
                                disabled={disableUpdate}
                            />
                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                {fieldErrorMessage('currency_id')}
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default QuoteForm;
